<template>
  <section id="opinions" class="content my-[100px] text-center">
    <h2 class="font-[600] text-[2rem] mb-[50px]">What they’ve said</h2>
    <swiper
      :modules="[Autoplay, Pagination]"
      :autoplay="{ delay: 3000, disableOnInteraction: false }"
      :loop="true"
      :pagination="{ clickable: true }"
      :breakpoints="{
        0: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      }"
    >
      <swiper-slide v-for="item in slides" :key="item.id">
        <div
          class="slide-content cursor-grab p-[10px] flex flex-col gap-[20px] items-center relative"
        >
          <img :src="item.image" :alt="item.name" class="w-[80px]" />
          <h2>{{ item.name }}</h2>
          <p class="text-[14px]">{{ item.description }}</p>
        </div>
      </swiper-slide>
    </swiper>

    <button class="btn-style mt-[80px]">Get Started</button>
  </section>
</template>

<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay, Pagination } from "swiper/modules";

// CSS بتاع Swiper
import "swiper/css";
import "swiper/css/pagination";

const slides = [
  {
    id: 1,
    name: "Anisha Li",
    description: `“Manage has supercharged our team’s workflow. The ability to maintain 
                  visibility on larger milestones at all times keeps everyone motivated.”`,
    image: require("../assets/images/avatar-anisha.png"),
  },
  {
    id: 2,
    name: "Ali Bravo",
    description: `“We have been able to cancel so many other subscriptions since using 
                  Manage. There is no more cross-channel confusion and everyone is much 
                  more focused.”`,
    image: require("../assets/images/avatar-ali.png"),
  },
  {
    id: 3,
    name: `Richard Watts`,
    description: `“Manage allows us to provide structure and process. It keeps us organized 
                  and focused. I can’t stop recommending them to everyone I talk to!”`,
    image: require("../assets/images/avatar-richard.png"),
  },
  {
    id: 4,
    name: `Shanai Gough`,
    description: `“Their software allows us to track, manage and collaborate on our projects 
                  from anywhere. It keeps the whole team in-sync without being intrusive.”`,
    image: require("../assets/images/avatar-shanai.png"),
  },
];
</script>

<style lang="scss">
.swiper {
  overflow: visible;
}
.slide-content {
  &::before {
    content: "";
    position: absolute;
    top: 50px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 200px;
    background-color: #f8f8f8;
    transform: translateX(-50%);
    border-radius: 10px;
    z-index: -1;
  }
}
.swiper-pagination {
  bottom: -50px !important;

  @media (min-width: 640px) {
    display: none;
  }
}

.swiper-pagination-bullet-active {
  background: $orange;
}
</style>
